import { BASE_PATH } from '@/app/components/search/utils/path';

type Gauge = 'gauge';
type Increment = 'increment';
type Timing = 'timing';
export type MetricType = Gauge | Increment | Timing;

type GaugeMetric = {
  name: string;
  value: number;
  type: Gauge;
};
type IncrementMetric = {
  name: string;
  type: Increment;
};
type TimingMetric = {
  name: string;
  value: number;
  type: Timing;
};

export type Metric = GaugeMetric | IncrementMetric | TimingMetric;

function sendMetric(payload: Metric) {
  const body = JSON.stringify(payload);
  const url = `${BASE_PATH}/api/hotel-detail/metrics`;
  if (navigator && navigator.sendBeacon) {
    navigator.sendBeacon(url, body);
  } else {
    fetch(url, {
      headers: { 'content-type': 'application/json' },
      method: 'POST',
      body,
    })
      .then((res) => res.text())
      .catch(() => {
        // Ignore errors - don't block metrics
      });
  }
}

export function sendMetricIncrement(name: string) {
  sendMetric({
    name,
    type: 'increment',
  });
}

export function sendMetricGauge(name: string, value: number) {
  sendMetric({
    name,
    value,
    type: 'gauge',
  });
}

export function sendMetricTiming(name: string, value: number) {
  sendMetric({
    name,
    value,
    type: 'timing',
  });
}

const onlyOnceMetricSent: string[] = [];

export function sendMetricGaugeOnce(name: string, value: number) {
  if (!onlyOnceMetricSent.includes(name)) {
    sendMetricGauge(name, value);
    onlyOnceMetricSent.push(name);
  }
}
